"use client"

import { Card, CardContent, CardFooter, CardHeader } from "../../../components/ui/card"
import { Button } from "../../../components/ui/button"
import { Badge } from "../../../components/ui/badge"
import { Eye, Trash2, Bell, Download, Mail, Phone, MapPin, CopyIcon } from "lucide-react"
import type { Project } from "./clients-modal"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog"
import { useState } from "react"

interface ProjectCardProps {
  project: Project
  onView: (project: Project) => void
  onEdit: (project: Project) => void
  onDelete: (id: string) => void
  onNotify: (project: Project) => void
  onDownload: (project: Project) => void
}

export function ProjectCard({ project, onView, onEdit, onDelete, onNotify, onDownload }: ProjectCardProps) {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)

  const handleDeleteClick = () => {
    setShowDeleteDialog(true)
  }

  const confirmDelete = () => {
    onDelete(project.id)
    setShowDeleteDialog(false)
  }

  return (
    <>
      <Card className="overflow-hidden hover:shadow-lg transition-shadow">
        <CardHeader className="p-0 relative">
          <div className="relative h-48 w-full bg-muted">
            <img
              src={
                "https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/images/" +
                  project.thumb || "/placeholder.svg"
              }
              alt={`Projeto ${project.orderNumber}`}
              className="object-contain h-full w-full"
            />
          </div>
          <Badge className="absolute top-3 left-3 bg-primary text-primary-foreground">{project.orderNumber}</Badge>
        </CardHeader>

        <CardContent className="p-4 space-y-3">
          <div>
            <h3 className="font-semibold text-lg text-foreground leading-tight">{project.name}</h3>
          </div>

          <div className="space-y-2 text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Phone className="h-4 w-4 flex-shrink-0" />
              <span className="truncate">{project.phone}</span>
            </div>

            <div className="flex items-center gap-2 text-muted-foreground">
              <Mail className="h-4 w-4 flex-shrink-0" />
              <span className="truncate">{project.email}</span>
            </div>

            <div className="flex items-center gap-2 text-muted-foreground">
              <MapPin className="h-4 w-4 flex-shrink-0" />
              <span className="truncate">{project.city}</span>
            </div>
          </div>

          <div className="pt-2">
            <p className="text-xs font-medium text-muted-foreground mb-2">Lista de Pedidos:</p>

            <div className="flex flex-wrap gap-1 flex-col">
              {/**{project.orderList.map((order, index) => (
                <span key={index}>{order}</span>
              ))} */}
            </div>

            <button
              onClick={() => {
                const textToCopy = project.orderList.join("\n")
                navigator.clipboard.writeText(textToCopy)
                alert("Descrição do cliente: " + textToCopy)
              }}
              className="mt-2 text-xs hover:bg-gray-300 text-black px-2 py-1 rounded flex bg-[orange]"
            >
              <CopyIcon className="h-4 w-4 mr-2" />
              Dados do pedido
            </button>
          </div>
        </CardContent>

        <CardFooter className="p-4 pt-0 flex gap-2">
          <Button variant="default" size="sm" className="flex-1" onClick={() => onView(project)}>
            <Eye className="h-4 w-4 mr-0" />
            {/**Visualizar */}
          </Button>

          <Button variant="default" size="sm" className="flex-1" onClick={() => onNotify(project)}>
            <Bell className="h-4 w-4 mr-0" />
            {/**Notificar */}
          </Button>

          <Button variant="default" size="sm" className="flex-1" onClick={() => onDownload(project)}>
            <Download className="h-4 w-4 mr-0" />
            {/**Baixar */}
          </Button>

          <Button variant="default" size="sm" className="flex-1" onClick={handleDeleteClick}>
            <Trash2 className="h-4 w-4 mr-0" />
              {/**Deletar */}
          </Button>
        </CardFooter>
      </Card>

      <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar exclusão</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja deletar o projeto {project.orderNumber} de {project.name}? Esta ação não pode ser
              desfeita.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={confirmDelete}
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            >
              Deletar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
